// frontend/src/features/sales-rep/components/ReactivationChart.tsx
import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell
} from 'recharts';
import { ReactivationData } from '../services/salesRepAPI';

interface ReactivationChartProps {
    data: ReactivationData[];
}

const ReactivationChart: React.FC<ReactivationChartProps> = ({ data }) => {
    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            notation: 'compact',
            compactDisplay: 'short'
        }).format(value);
    };

    const CustomTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            return (
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    padding: '12px',
                    border: '1px solid var(--border-primary)',
                    borderRadius: 'var(--radius-base, 8px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>{payload[0].payload.nomeVendedor}</p>
                    <p style={{ color: '#dd1518', margin: '4px 0' }}>
                        Clientes Reativados: {payload[0].value}
                    </p>
                    <p style={{ color: '#666', margin: '4px 0' }}>
                        Faturamento: {formatCurrency(payload[0].payload.faturamentoReativados)}
                    </p>
                </div>
            );
        }
        return null;
    };

    // Define cores gradientes baseadas no ranking
    const getColor = (index: number) => {
    const colors = [
        '#F03A3D', // mais saturado e vibrante
        '#DD1518',
        '#DD1518', // cor principal
        '#B01214', // mais escuro e forte
    ];
    return colors[index] || '#960f11ff';
};

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data}
                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                onMouseDown={(_, event) => event.preventDefault()}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis
                    dataKey="nomeVendedor"
                    angle={-45}
                    textAnchor="end"
                    height={80}
                    tick={{ fontSize: 12 }}
                />
                <YAxis 
                    tick={{ fontSize: 12 }}
                    allowDecimals={false}
                />
                <Tooltip content={<CustomTooltip />} />
                <Bar 
                    dataKey="totalReativacoes" 
                    name="Clientes Reativados"
                    radius={[0, 0, 0, 0]}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={getColor(index)} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ReactivationChart;